import React from 'react';
import { useTheme, Paper, Typography } from '@mui/material';
import ISODateTime from 'components/formatting/ISODateTime';
import { Dataset } from './Dataset';


export interface DatasetRowProps {
  dataset: Dataset;
  selectedDatasetId?: string;
  isSocialData?: boolean;

  onClick?: (dataset: Dataset | undefined) => void;
}

export default function DatasetRow(props: DatasetRowProps): JSX.Element {
  const theme = useTheme();

  return (
    <Paper sx={{
      mb: 1,
      p: 1,
      pl: 2,
      position: "relative",
      cursor: "pointer",
      border: props.selectedDatasetId === props.dataset.id ? "2px solid " + theme.palette.primary.main : "none",
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
     }}
     onClick={() => props.onClick && props.onClick(undefined)}
     >
      <Typography variant="h4" sx={{p: 0, m:0}}>
        {props.dataset.name}
      </Typography>
      {!props.isSocialData &&
        <Typography>
          {props.dataset?._user?.name}
        </Typography>
      }
      {props.isSocialData &&
        <Typography>
          {props.dataset.description}
        </Typography>
      }
      {!props.isSocialData &&
        <Typography sx={{ color: theme.palette.text.secondary }}>
          {props.dataset.created_at &&
            <ISODateTime isoString={props.dataset.created_at} />
          }
        </Typography>
      }
    </Paper>
  );
}
